import { BusinessModel } from '../../interfaces/BusinessModel.interface';
import IntakeConfig from '../../interfaces/IntakeConfig.interface';

const getCoupons = (business: BusinessModel, config: IntakeConfig): Array<string> => {
  if (!config.coupons) return [];
  if (Array.isArray(config.coupons)) return config.coupons;
  if (config.coupons instanceof Function) return config.coupons(business);
  throw new Error('Invalid config value for coupons');
};

export default getCoupons;
